import { Component } from '@angular/core';
import { BasicService } from '../../services/basic.service';

@Component({
  selector: 'app-emoji-picker-modal',
  templateUrl: './emoji-picker-modal.component.html',
  styleUrls: ['./emoji-picker-modal.component.scss'],
})
export class EmojiPickerModalComponent {
  constructor(private basicService: BasicService) {}

  dismissModal() {
    this.basicService.dismissModal();
  }

  onEmojiSelected(emoji) {
    this.basicService.dismissModal(emoji);
  }
}
